var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1054_48323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6206 7.81124C32.611 7.72631 32.5115 6.96582 31.994 6.44889L26.1756 0.631041C25.6586 0.114111 24.8982 0.0134256 24.8138 0.00386323C24.7924 0.00161326 24.771 0.000488281 24.7497 0.000488281H8.43742C6.88663 0.000488281 5.62496 1.26216 5.62496 2.81294V12.9378H5.06247C4.13211 12.9378 3.375 13.6949 3.375 14.6253V21.3752C3.375 22.3055 4.13211 23.0626 5.06247 23.0626H5.62496V33.1875C5.62496 34.7383 6.88663 35.9999 8.43742 35.9999H29.8121C31.3629 35.9999 32.6245 34.7383 32.6245 33.1875V7.87537C32.6245 7.85343 32.6234 7.83262 32.6206 7.81124Z",
    fill: "url(#paint0_linear_1054_48323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8122 12.9377H5.06247C4.13211 12.9377 3.375 13.6949 3.375 14.6252V21.3751C3.375 22.3055 4.13211 23.0626 5.06247 23.0626H20.8122C21.7426 23.0626 22.4997 22.3055 22.4997 21.3751V14.6252C22.4997 13.6943 21.7432 12.9377 20.8122 12.9377Z",
    fill: "url(#paint1_linear_1054_48323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9943 6.44896L26.1759 0.631115C25.659 0.114186 24.8985 0.0134999 24.8141 0.00393755C24.6555 -0.0151871 24.4957 0.0359996 24.3754 0.143435C24.2561 0.249746 24.1875 0.402181 24.1875 0.563054V5.62547C24.1875 7.17626 25.4492 8.43793 27 8.43793H32.0624C32.2227 8.43793 32.3757 8.36931 32.482 8.25006C32.5883 8.13025 32.6389 7.97106 32.6209 7.81188C32.6119 7.72638 32.5118 6.96589 31.9943 6.44896Z",
    fill: "url(#paint2_linear_1054_48323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43747 15.1877H7.31249C7.00143 15.1877 6.75 15.4397 6.75 15.7502V20.2502C6.75 20.5607 7.00143 20.8127 7.31249 20.8127C7.62355 20.8127 7.87498 20.5607 7.87498 20.2502V19.1252H8.43747C9.36783 19.1252 10.1249 18.3681 10.1249 17.4377V16.8752C10.1249 15.9443 9.3684 15.1877 8.43747 15.1877ZM8.99997 17.4377C8.99997 17.7476 8.74797 18.0002 8.43747 18.0002H7.87498V16.3127H8.43747C8.74797 16.3127 8.99997 16.5653 8.99997 16.8752V17.4377Z",
    fill: "url(#paint3_linear_1054_48323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 17.4377H16.875V16.3127H18.5625C18.8735 16.3127 19.1249 16.0607 19.1249 15.7502C19.1249 15.4397 18.8735 15.1877 18.5625 15.1877H16.3125C16.0014 15.1877 15.75 15.4397 15.75 15.7502V20.2502C15.75 20.5607 16.0014 20.8127 16.3125 20.8127C16.6235 20.8127 16.875 20.5607 16.875 20.2502V18.5627H18.5625C18.8735 18.5627 19.1249 18.3107 19.1249 18.0002C19.1249 17.6897 18.8735 17.4377 18.5625 17.4377Z",
    fill: "url(#paint4_linear_1054_48323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 15.1877H11.8125C11.5014 15.1877 11.25 15.4397 11.25 15.7502V20.2502C11.25 20.5607 11.5014 20.8127 11.8125 20.8127H12.9375C13.8678 20.8127 14.6249 20.0555 14.6249 19.1252V16.8752C14.6249 15.9443 13.8684 15.1877 12.9375 15.1877ZM13.5 19.1252C13.5 19.4351 13.248 19.6877 12.9375 19.6877H12.375V16.3127H12.9375C13.248 16.3127 13.5 16.5653 13.5 16.8752V19.1252Z",
    fill: "url(#paint5_linear_1054_48323)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1054_48323",
    x1: 4.20017,
    y1: 32.9248,
    x2: 31.3353,
    y2: 5.78966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3D8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E7F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1054_48323",
    x1: 6.11996,
    y1: 24.8176,
    x2: 19.7553,
    y2: 11.1822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005ECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2488FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1054_48323",
    x1: 25.0127,
    y1: 7.61276,
    x2: 29.0857,
    y2: 3.53976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00969B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1054_48323",
    x1: 5.78983,
    y1: 19.5229,
    x2: 9.63052,
    y2: 15.6822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3D8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E7F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1054_48323",
    x1: 14.7898,
    y1: 19.5229,
    x2: 18.9601,
    y2: 15.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3D8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E7F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1054_48323",
    x1: 10.6875,
    y1: 19.92,
    x2: 14.5276,
    y2: 16.0799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3D8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E7F8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1054_48323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/pdf-file.0f7565ee0e07c861eb43b414e0072dec.svg";
export { ForwardRef as ReactComponent };